import Chart from 'react-apexcharts';
import {bold} from "jodit/types/plugins/bold/bold";
type ChartProps = React.ComponentProps<typeof Chart>;

const chartData: ChartProps = {
    height: "350",
    type: 'bar',
    options: {
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '90%',
                borderRadius:10,
                borderRadiusApplication: "end",
                colors:{
                    ranges:[{
                        from:0,
                        to:29,
                        color:'#f44319'
                    },{
                        from:30,
                        to:54,
                        color:'#ffa227'
                    },
                    {
                        from:55,
                        to:74,
                        color:'#ffda03'
                    },
                    {
                        from:75,
                        to:100,
                        color:'#49cb0f'
                    }
                    ]
                }
            }
        },
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return val + '%';
            },
            style:{
                fontWeight: 600,
                fontSize:'14px',
            }
        },
        colors: ['#FFA403','#ce4d1f',  '#79B0AB'],
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: [

            ],
            labels:{
                rotate: -45,

            },
            title:{
                text: 'Desempeño',
                style:{
                    fontWeight: 200,
                    fontSize: '15px',

                }
            }

        },
        yaxis:{
            title:{
                text: 'Porcentaje alcanzado grupal',
                style:{
                    fontWeight: 200,
                    fontSize: '15px',
                }
            },
            labels: {
                show: false,
            }
        },

        fill: {
            opacity: 1
        },
        tooltip: {

        }
    },
    series: [

    ]
};
export default chartData;
